import dayjs from "dayjs";

export const DEFAULT_TEST_CASE = [
  {
    title: "Get profile",
    isPassed: false,
    error: "",
  },
  {
    title: "Get profile with no username exist",
    isPassed: false,
    error: "",
  },
  {
    title: "Placebet",
    isPassed: false,
    error: "",
  },
  {
    title: "Test bet cancel",
    isPassed: false,
    error: "",
  },
  {
    title: "Test bet win",
    isPassed: false,
    error: "",
  },
  {
    title: "Test bet half win",
    isPassed: false,
    error: "",
  },
  {
    title: "Test bet half lose",
    isPassed: false,
    error: "",
  },
  {
    title: "Test bet lose",
    isPassed: false,
    error: "",
  },
  {
    title: "Test bet draw",
    isPassed: false,
    error: "",
  },
];

export const DEFAULT_DATE_PICKER = {
  startDate: dayjs().startOf("month").toDate(),
  endDate: dayjs().endOf("month").toDate(),
};

export interface SportType {
  value: string;
  label: string;
}

export const sportTypes: SportType[] = [
  { value: '',        label: 'All Sport' },
  { value: 'FOOTBALL',        label: 'Football' },
  { value: 'BASKETBALL',      label: 'Basketball' },
  { value: 'CRICKET',         label: 'Cricket' },
  { value: 'VOLLEYBALL',      label: 'Volleyball' },
  { value: 'TABLETENNIS',     label: 'TableTennis' },
  { value: 'HANDBALL',        label: 'Handball' },
  { value: 'ICEHOCKEY',       label: 'Icehockey' },
  { value: 'TENNIS',          label: 'Tennis' },
  { value: 'SNOOKER',         label: 'Snooker' },
  { value: 'BASEBALL',        label: 'Baseball' },
  { value: 'RUGBY',           label: 'Rugby' },
  { value: 'BOXING',          label: 'Boxing' },
  { value: 'AMERICANFOOTBALL', label: 'AmericanFB' },
  { value: 'BADMINTON',       label: 'Badminton' },
];

export const GLOBAL_CURRENCIES = ["THB","CNY","IDR","KHR","LAK","MMK","MYR","USD","VND"];

export interface Profile {
  _id: string;
  username: string;
  nickname: string;
  parent: string;
  parentList: string[];
}

